// extracted by mini-css-extract-plugin
export default {"Box":"route-title-module__Box--ORx_6","Octicon":"route-title-module__Octicon--QRcNh","Heading":"route-title-module__Heading--X_5sq"};